import {
    defaultActivitiesResource,
    useActivitiesActions,
} from '../../../../resource/resources/artifacts/activities/activitiesResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaActivityAssociationResource,
    useProcessAreaActivityAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaActivityAssociationResource';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { BPMNModelerViewer } from './BPMNModelerViewer';
import { useParams } from 'react-router-dom';
import { useMyNavigate } from '../../../router/createdRouter';

export const StackedActivitiesView = ({ isAdmin, processAreaId, versionId, link }: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    link: string | undefined
}) => {
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();
    const { id: projectId, standardId, useCaseId } = useParams<{ id: string, standardId: string, useCaseId: string }>();
    const navigate = useMyNavigate();
    const activityAssociationActions = useProcessAreaActivityAssociationActions()
    const activityActions = useActivitiesActions()
    const activityAssociationsQuery = activityAssociationActions.useGetSingleResource(processAreaId);
    const activityQuery = activityActions.useGetResourceByObjectIdAndVersionedIn(
        activityAssociationsQuery.data?.activities,
        versionId,
    );
    const activitiesQuery = activityActions.useGetAllResources(versionId);

    const deleteActivityAssociation = activityAssociationActions.useDeleteResource();
    const addActivityAssociation = activityAssociationActions.useSetResource();
    const addActivity = activityActions.useAddResource();

    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        'Select or Create a Activity',
        activitiesQuery.data?.map(activity => ({ label: activity.name, value: activity.objectId })) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addActivityAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaActivityAssociationResource,
                        activities: value,
                    },
                    parentId: processAreaId,
                });
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addActivity.mutateAsync({
                        resource: {
                            ...defaultActivitiesResource,
                            name: value,
                            description: multiLineValue ?? '',
                        },
                        parentId: versionId,
                    },
                    {
                        onSuccess: (result) => {
                            const activityObjectId = result?.content?.objectId;
                            if (activityObjectId) {
                                addActivityAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaActivityAssociationResource,
                                        activities: activityObjectId,
                                    },
                                    parentId: processAreaId,
                                });
                            }
                        },
                    },
                );
            }
        },
        undefined,
        'Name',
        true,
        'Description',
        800,
    );

    const onDelete = () => {
        const id = activityAssociationsQuery.data?.id;
        if (id) {
            deleteResourceDialogFunction.deleteResource(
                id, null, ResourceType.PROCESS_AREA_ACTIVITIES_ASSOCIATION, deleteActivityAssociation,
            );
        }
    };

    const onEdit = () => {
        const id = activityQuery.data?.id;
        if (id && projectId && versionId) {
            if (standardId && useCaseId) {
                navigate({
                    route: '/project/:id/active-version/:versionId/activities-model/:activitiesId/standard/:standardId/use-case/:useCaseId',
                    routeParams: {
                        id: projectId,
                        versionId,
                        activitiesId: id,
                        standardId,
                        useCaseId,
                    },
                });
            } else {
                navigate({
                    route: '/project/:id/active-version/:versionId/activities-model/:activitiesId',
                    routeParams: {
                        id: projectId,
                        versionId,
                        activitiesId: id,
                    },
                });
            }
        }
    };

    return (
        <BPMNModelerViewer
            key={activityAssociationsQuery.data?.id}
            activityId={activityQuery.data?.id}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
        />
    );
};